export default {
  patient: {
    welcome: 'Bonjour ! Voici votre résumé de santé',
    welcomeName: 'Bonjour, {{name}} !',
    newAppointment: 'Nouveau Rendez-vous',
    actionRequired: 'Action Requise',
    nextConsultation: 'Prochaine consultation',
    keepControl: 'Gardez le contrôle sur votre santé',
    noAppointment: 'Aucun rendez-vous planifié pour le moment.',
    joinWaitingRoom: "Rejoindre la salle d'attente",
    bookNow: 'Prendre RDV maintenant',
    manageActivities: 'Gérer mes activités',
    messages: 'Messages',
    unread: 'non lus',
    vitals: 'Vos Constantes',
    live: 'En direct',
    pulse: 'Pouls',
    bloodPressure: 'Tension',
    weight: 'Poids',
    temperature: 'Température',
    justUpdated: "Mis à jour à l'instant",
    noData: 'Aucune donnée',
    activePrescriptions: 'Ordonnances Actives',
    prescription: 'Ordonnance',
    recentMedicalRecords: 'Dossiers Médicaux Récents',
    viewAll: 'Tout voir',
    medication: 'Médicament',
    unknownDoctor: 'Inconnu',
    noActivePrescription: 'Aucune ordonnance active.',
    recentActivity: 'Activité Récente',
    completedConsultation: 'Consultation terminée',
    pendingConsultation: 'Consultation en attente',
    withDoctor: 'avec le Dr. {{name}}',
    details: 'Détails',
    noHistory: 'Votre historique de consultation apparaîtra ici.',
    patient: 'Patient',
    doctor: 'Médecin',
    generalist: 'Généraliste',
    clinicalConsultation: 'Consultation Clinique',
    consultationWithDoctor: 'Consultation avec le Dr. {{name}}',
    medicalFollowUp: 'Suivi médical',
    emergency: {
      title: "Protocole d'Urgence",
      subtitle: "Assistance immédiate",
      description: "En cas d'urgence immédiate (douleur thoracique, difficultés respiratoires, perte de connaissance), n'attendez pas de téléconsultation. Le SAMU est votre priorité absolue.",
      callSamu: "APPELER LE 15",
      europe: "EUROPE (112)"
    },
    conflictModal: {
      title: "Session Active",
      subtitle: "Une téléconsultation est déjà en cours.",
      description: "Il semble que vous ayez déjà une session ouverte. Souhaitez-vous la rejoindre pour poursuivre votre échange médical ?",
      rejoin: "Rejoindre la Consultation",
      cancel: "Annuler"
    }
  },
  notificationCenter: {
    unreadAlerts_one: '{{count}} Notification Prioritaire',
    unreadAlerts_other: '{{count}} Notifications Prioritaires',
    noActiveAlerts: 'Aucune Alerte active',
    markAsRead: 'Marquer comme lu',
    dismiss: 'Supprimer'
  },
  doctor: {
    availabilityControl: {
      title: 'Statut de disponibilité',
      update: 'Mettre à jour',
      updating: 'Mise à jour...',
      activeStatus: 'ACTIF',
      lastCheck: 'Dernier check : {{time}}',
      available: {
        label: 'Disponible',
        desc: 'Prêt pour consultations'
      },
      busy: {
        label: 'Occupé',
        desc: 'En consultation'
      },
      offline: {
        label: 'Hors ligne',
        desc: 'Indisponible'
      }
    }
  },
  invoicesSection: {
    title: 'Mes Factures & Paiements',
    fetchingDocuments: 'Récupération de vos documents...',
    noInvoiceAvailable: 'Aucune facture disponible pour le moment.',
    invoiceNumber: 'Facture #{{id}}',
    paid: 'Payée',
    downloadPdf: 'Télécharger en PDF',
    viewFullHistory: "VOIR TOUT L'HISTORIQUE",
    documentsCount_one: '{{count}} DOCUMENT',
    documentsCount_other: '{{count}} DOCUMENTS'
  },
  healthQuest: {
    quests: {
      identity: 'Identité Validée',
      phone: 'Ligne de Vie Active',
      medical: 'Terrain Médical',
      emergency: 'Ange Gardien'
    },
    ranks: {
      elite: 'PATIENT ÉLITE',
      adept: 'ADEPTE SANTÉ',
      initiate: 'INITIÉ SANTÉ'
    },
    title: 'Votre Ascension Santé',
    rankLabel: 'RANG :',
    continueQuest: 'Poursuivre ma Quête'
  },
  doctorDashboard: {
    doctorPrefix: 'Dr. {{name}}',
    doctor: 'Médecin',
    securedHds: 'Sécurisé HDS',
    interfaceElite: 'Interface Elite • Session Active',
    newSession: 'Nouvelle Session',
    live: 'En Direct',
    activeConsultation: 'Consultation Active',
    patientNumber: 'Patient #{{id}}',
    startedAt: 'Démarrée à {{time}}',
    statusLabel: 'Statut : {{status}}',
    rejoinCall: "Rejoindre l'Appel",
    todayAppointments: 'Rendez-vous du jour',
    today: "Aujourd'hui",
    viewAll: 'Voir Tout',
    generalConsultation: 'Consultation générale',
    noAppointmentPlanned: 'Aucun rendez-vous prévu',
    stats: {
      waitingQueue: "File d'attente",
      patients: 'Patients',
      emergencies: 'Urgences',
      immediateAction: 'Action Immédiate',
      nextAppointment: 'Prochain RDV',
      freeSlot: 'Libre'
    },
    timeline: 'Timeline',
    activityStream: "Flux d'activité",
    noUpcomingEvent: 'Aucun événement à venir',
    ekoseConsultation: 'Consultation EKOSE',
    alertsCenter: 'CENTRE DES ALERTES',
    messages: 'Messages',
    quickActions: 'ACTIONS RAPIDES',
    waitingRoom: "Salle d'attente",
    prescriptions: 'Ordonnances'
  },
  performance: {
    title: 'Monitoring des Performances API',
    timeWindow: 'Fenêtre temporelle',
    timeWindows: {
      oneMin: '1 minute',
      fiveMin: '5 minutes',
      fifteenMin: '15 minutes',
      oneHour: '1 heure',
      sinceBeginning: 'Depuis le début'
    },
    totalRequests: 'Requêtes totales',
    averageResponseTime: 'Temps de réponse moyen',
    errorRate: "Taux d'erreur",
    slowRequests: 'Requêtes lentes',
    ofTotal: '{{percentage}}% du total',
    responseTime: 'Temps de réponse',
    fastest: 'Plus rapide : {{time}}ms',
    slowest: 'Plus lent : {{time}}ms',
    average: 'Moyenne : {{time}}ms',
    slowestEndpoints: 'Endpoints les plus lents',
    noData: 'Aucune donnée disponible',
    globalHealth: 'Santé globale',
    performanceLabel: 'Performance',
    stability: 'Stabilité',
    exportData: 'Exporter les données',
    close: 'Fermer'
  },
  charts: {
    donut: {
      defaultTitle: 'Répartition des Utilisateurs',
      subtitle: 'Répartition par typologie de profil',
      users: 'Utilisateurs',
      growthRate: 'Taux Croissance',
      activeUsers: 'Utilisateurs Actifs',
      registrations24h: 'Inscriptions 24h',
      labels: {
        patients: 'Patients',
        doctors: 'Médecins',
        medecins: 'Médecins',
        administrators: 'Administrateurs',
        admins: 'Admins'
      }
    },
    activity: {
      title: 'Activité Hebdomadaire',
      subtitle: 'Suivi en temps réel des interactions',
      total: 'TOTAL',
      legends: {
        consults: 'Consults',
        registrations: 'Inscripts',
        messages: 'Messages'
      },
      categories: {
        consultations: 'Consultations',
        registrations: 'Inscriptions',
        messages: 'Messages'
      },
      days: {
        lun: 'Lun',
        mar: 'Mar',
        mer: 'Mer',
        jeu: 'Jeu',
        ven: 'Ven',
        sam: 'Sam',
        dim: 'Dim',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun'
      }
    }
  }
};
